import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { FC, memo } from 'react';
import { Checkbox, Radio, Switch } from 'udesk-ui';
import AutomaticAllocationItem from './components/AutomaticAllocationItem';

export const TriggerStrategyMap = {
    Passing: 1,
    All: 2,
};

interface TemplateProps {
    disabled?: boolean;
    assignShowType?: any;
    onAssignTypeChange?: () => void;
    isComment?: boolean;
    sampleAssign?: any;
    onValueChanged?: (k: string, v: any) => void;
    model?: any;
    sampleAssignListChanged?: () => void;
    taskId?: any;
    taskName?: string;
    type?: number;
    defaultSampleAssignConf?: any;
    sdkOptions?: any;
    reviewAssign?: any;
    reviewAssignSecondLevel?: any;
    reviewAssignListChanged?: () => void;
    reviewAssignSecondLevelListChanged?: () => void;
    defaultReviewAssignConf?: any;
    defaultReviewAssignConfSecondLevel?: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        disabled,
        assignShowType,
        onAssignTypeChange,
        isComment,
        sampleAssign,
        onValueChanged,
        model,
        sampleAssignListChanged,
        taskId,
        taskName,
        type,
        defaultSampleAssignConf,
        sdkOptions,
        reviewAssign,
        reviewAssignSecondLevel,
        reviewAssignListChanged,
        reviewAssignSecondLevelListChanged,
        defaultReviewAssignConf,
        defaultReviewAssignConfSecondLevel,
    } = props;

    const locales = UdeskLocales['current'];

    console.log(
        'assign',
        reviewAssign,
        defaultReviewAssignConf,
        reviewAssignSecondLevel,
        defaultReviewAssignConfSecondLevel
    );

    return (
        <>
            <Radio.Group
                defaultValue={assignShowType}
                onChange={onAssignTypeChange}
                buttonStyle="solid"
                style={{ marginBottom: 16 }}
            >
                <Radio.Button value="sampleAssign">
                    {
                        locales.pages.tasks.manage.template.automaticAdd.index
                            .sampleInspectionDistributionModel
                    }
                </Radio.Button>

                {!isComment ? (
                    <Radio.Button value="reviewAssign">
                        {
                            locales.pages.tasks.manage.template.automaticAdd.index
                                .reviewAllocationModel
                        }
                    </Radio.Button>
                ) : null}
            </Radio.Group>

            <div className="automatic-content-item-body">
                {assignShowType === 'sampleAssign' ? (
                    <AutomaticAllocationItem
                        title={
                            locales.pages.tasks.manage.template.automaticAdd.index
                                .distributionModelTitle
                        }
                        assignModelValue={sampleAssign.assignModel}
                        onAssignModelValueChange={(e) =>
                            onValueChanged?.('sampleAssign', {
                                ...sampleAssign,
                                assignModel: e.target.value,
                            })
                        }
                        disabled={disabled}
                        assignConfList={[...sampleAssign.assignConfList]}
                        fields={model.customFields}
                        onAssignConfListChange={sampleAssignListChanged}
                        users={model.users}
                        taskId={taskId}
                        taskName={taskName}
                        inspectDataSource={type}
                        notMatchValue={defaultSampleAssignConf.assignType}
                        onNotMatchValueChange={(e) =>
                            onValueChanged?.('defaultSampleAssignConf', {
                                ...defaultSampleAssignConf,
                                assignType: e.target.value,
                            })
                        }
                        notMatchSelectValue={defaultSampleAssignConf.inspectorList}
                        onNotMatchSelectValueChange={(e) =>
                            onValueChanged?.('defaultSampleAssignConf', {
                                ...defaultSampleAssignConf,
                                inspectorList: e,
                            })
                        }
                        getUserListUrl={Udesk.business.apiPath.concatApiPath(
                            '/users?pageSize=1000',
                            sdkOptions
                        )}
                    />
                ) : null}

                {assignShowType === 'reviewAssign' ? (
                    <>
                        <div className="automatic-content-item-body-item">
                            <div
                                className="automatic-content-item-body-item-title automatic-content-item-body-item-title-screening-condition"
                                style={{ fontWeight: 'bold' }}
                            >
                                {/* 一级复核 */}
                                {
                                    UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                                        .components.autoAssign.index.firstlevelReview
                                }
                            </div>
                        </div>

                        <AutomaticAllocationItem
                            title={
                                locales.pages.tasks.manage.template.automaticAdd.index
                                    .distributionModelTitle
                            }
                            assignModelValue={reviewAssign.assignModel}
                            onAssignModelValueChange={(e) =>
                                onValueChanged?.('reviewAssign', {
                                    ...reviewAssign,
                                    assignModel: e.target.value,
                                })
                            }
                            disabled={disabled}
                            assignConfList={[...reviewAssign.assignConfList]}
                            fields={model.customFields}
                            onAssignConfListChange={reviewAssignListChanged}
                            users={model.users}
                            taskId={taskId}
                            taskName={taskName}
                            inspectDataSource={type}
                            notMatchValue={defaultReviewAssignConf.assignType}
                            onNotMatchValueChange={(e) =>
                                onValueChanged?.('defaultReviewAssignConf', {
                                    ...defaultReviewAssignConf,
                                    assignType: e.target.value,
                                })
                            }
                            notMatchSelectValue={defaultReviewAssignConf.inspectorList}
                            onNotMatchSelectValueChange={(e) =>
                                onValueChanged?.('defaultReviewAssignConf', {
                                    ...defaultReviewAssignConf,
                                    inspectorList: e,
                                })
                            }
                            getUserListUrl={Udesk.business.apiPath.concatApiPath(
                                '/users?pageSize=1000',
                                props.sdkOptions
                            )}
                        />

                        <div className="automatic-content-item-body-item" style={{ gap: 8 }}>
                            <div
                                className="automatic-content-item-body-item-title automatic-content-item-body-item-title-screening-condition"
                                style={{ fontWeight: 'bold' }}
                            >
                                {/* 二级复核 */}
                                {
                                    UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                                        .templateNew.secondaryReview
                                }
                            </div>
                            <div className="automatic-content-item-body-item-content">
                                <Switch
                                    size="small"
                                    checked={
                                        // 这里，兼容以前的配置
                                        !!reviewAssignSecondLevel.enabledSecondLevelRecheck
                                    }
                                    onChange={(e) =>
                                        onValueChanged?.('reviewAssignSecondLevel', {
                                            ...reviewAssignSecondLevel,
                                            enabledSecondLevelRecheck: e,
                                        })
                                    }
                                />
                            </div>
                        </div>

                        {reviewAssignSecondLevel.enabledSecondLevelRecheck ? (
                            <>
                                <div className="automatic-content-item-body-item">
                                    <div className="automatic-content-item-body-item-title automatic-content-item-body-item-title-screening-condition">
                                        {/* 触发策略： */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.autoAssign.index
                                                .triggerPolicy
                                        }
                                    </div>

                                    <div className="automatic-content-item-body-item-content">
                                        <Radio.Group
                                            options={[
                                                {
                                                    label: /* 仅通过时二级复核 */ UdeskLocales[
                                                        'current'
                                                    ].pages.tasks.manage.template.automaticAdd
                                                        .components.autoAssign.index
                                                        .secondaryReviewOnlyWhenPassing,
                                                    value: TriggerStrategyMap.Passing,
                                                },
                                                {
                                                    label: /* 所有结果二级复核 */ UdeskLocales[
                                                        'current'
                                                    ].pages.tasks.manage.template.automaticAdd
                                                        .components.autoAssign.index
                                                        .secondaryReviewOfAllResults,
                                                    value: TriggerStrategyMap.All,
                                                },
                                            ]}
                                            value={reviewAssignSecondLevel.secondLevelRecheckScope}
                                            onChange={(e) =>
                                                onValueChanged?.('reviewAssignSecondLevel', {
                                                    ...reviewAssignSecondLevel,
                                                    secondLevelRecheckScope: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </div>

                                <div style={{ marginBottom: 8 }}>
                                    <Checkbox
                                        checked={
                                            reviewAssignSecondLevel.enabledAutoSecondReview === 1
                                        }
                                        onChange={(e) =>
                                            onValueChanged?.('reviewAssignSecondLevel', {
                                                ...reviewAssignSecondLevel,
                                                enabledAutoSecondReview: e.target.checked ? 1 : 0,
                                            })
                                        }
                                    >
                                        {/* 二级复核分配人等于一级复核提交人时，自动完成二级复核 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.autoAssign.index
                                                .whenTheSecondlevelReviewAssignerIsEqualToTheFirstlevelReviewSubmiterTheSecondlevelReviewIsAutomaticallyCompleted
                                        }
                                    </Checkbox>
                                </div>

                                <AutomaticAllocationItem
                                    title={
                                        locales.pages.tasks.manage.template.automaticAdd.index
                                            .distributionModelTitle
                                    }
                                    assignModelValue={reviewAssignSecondLevel.assignModel}
                                    onAssignModelValueChange={(e) =>
                                        onValueChanged?.('reviewAssignSecondLevel', {
                                            ...reviewAssignSecondLevel,
                                            assignModel: e.target.value,
                                        })
                                    }
                                    disabled={disabled}
                                    assignConfList={[...reviewAssignSecondLevel.assignConfList]}
                                    fields={model.customFields}
                                    onAssignConfListChange={reviewAssignSecondLevelListChanged}
                                    users={model.users}
                                    taskId={taskId}
                                    taskName={taskName}
                                    inspectDataSource={type}
                                    notMatchValue={defaultReviewAssignConfSecondLevel.assignType}
                                    onNotMatchValueChange={(e) =>
                                        onValueChanged?.('defaultReviewAssignConfSecondLevel', {
                                            ...defaultReviewAssignConfSecondLevel,
                                            assignType: e.target.value,
                                        })
                                    }
                                    notMatchSelectValue={
                                        defaultReviewAssignConfSecondLevel.inspectorList
                                    }
                                    onNotMatchSelectValueChange={(e) =>
                                        onValueChanged?.('defaultReviewAssignConfSecondLevel', {
                                            ...defaultReviewAssignConfSecondLevel,
                                            inspectorList: e,
                                        })
                                    }
                                    getUserListUrl={Udesk.business.apiPath.concatApiPath(
                                        '/users?pageSize=1000',
                                        props.sdkOptions
                                    )}
                                    showSpecify
                                    secondLevelInspectors={
                                        reviewAssignSecondLevel.secondLevelInspectors
                                    }
                                    onSecondLevelInspectorsChange={(e) =>
                                        onValueChanged?.('reviewAssignSecondLevel', {
                                            ...reviewAssignSecondLevel,
                                            secondLevelInspectors: e,
                                        })
                                    }
                                />
                            </>
                        ) : null}
                    </>
                ) : null}
            </div>
        </>
    );
});

export default Template;
